module.exports = __webpack_public_path__ + "img/2.9b261865.png";